import { Box, Tooltip } from '@mui/material'
import React, { ReactElement } from 'react'

type TooltipPlacement =
  | 'right'
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'top-end'
  | 'top-start'
  | 'top'

type BasicTooltipProps = {
  children: ReactElement
  title: ReactElement
  placement?: TooltipPlacement
  followCursor?: boolean
  small?: boolean
}

const BasicTooltip = ({ children, title, placement = 'right', followCursor, small }: BasicTooltipProps) => {
  return (
    <Tooltip
      placement={placement}
      followCursor={followCursor}
      arrow
      title={
        <Box
          sx={{
            maxHeight: 500,
            padding: 0,
            width: 'auto',
            paddingY: small ? 0.5 : 1,
            paddingX: small ? 1 : 2,
          }}
        >
          {title}
        </Box>
      }
    >
      {children}
    </Tooltip>
  )
}

export default BasicTooltip